import React, { Component, Fragment } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CadeComponentHeader from './CadeComponentHeader';
import CadeComponentDoodle from './CadeComponentDoodle';
import Moment from 'react-moment';
import moment from 'moment-timezone';
import { ResponsiveContainer, BarChart, Bar, LineChart, Line, XAxis, YAxis, Cell, CartesianGrid, Tooltip, Legend } from 'recharts';
import authService from '../../services/AuthService';
import api, { apiErrorHandler, apiResponseHandler } from '../../services/AxiosService';

import './CadeMonitor.css';
import CadeDomainCompareRadar from './CadeDomainCompareRadar';
import { apiErrorPopup } from '../../helpers/MessagePopup';

class CadeMonitorAssessmentComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            assessmentId: props.assessmentId,
            assessmentDate: props.assessmentDate,
            providerId: props.providerId,
            cadeMode: props.cadeMode,
            cadeModeFor: props.cadeModeFor,
            cadeDomainId: 0,
            cadeDomain: props.cadeDomain,
            domainDisplayName: props.domainDisplayName,
            domainImage: props.domainImage + "LG.png",
            startDate: null,
            endDate: null,
            isAvailable: false,
            progressInfo: [], 
            progressCompare: []
        }
    }

    componentDidMount = () => {
        /*
         * Run a query to get the progress model
         */

        let url = "assessment/" + this.state.assessmentId + "/domain/" + this.state.cadeDomain + "/caiu/" + authService.authenticatedUserId + "/" + this.state.cadeMode + "/" + this.state.cadeModeFor +
            "/aun/" + authService.authenticatedUserName + "/prvId/" + this.props.providerId;
        api.get(url, {
            headers: {
                Authorization: 'Bearer ' + authService.token
            }
        })
            .then((response) => {
                if (response.status === 200) {
                    this.setState({
                        startDate: response.data.startDate,
                        endDate: response.data.endDate,
                        progressInfo: response.data.progressInfo,
                        progressCompare: response.data.progressCompare,
                        isAvailable: response.data.isAvailable
                    });
                }
                else {
                    apiErrorPopup(apiResponseHandler(response));
                }
            })
            .catch(error => {
                // Major problem - should not happen.  Back to login?
                apiErrorPopup(apiErrorHandler(error));
            });
    }

    render() {
        
        let subTitle = "Progress Monitor";
        let mStartDate = null;
        let sStartDate = null;
        let mEndDate = null;
        let sEndDate = null;
        if (this.state.isAvailable) {
            mStartDate = moment.utc(this.state.startDate).tz(moment.tz.guess());
            sStartDate = mStartDate.format("MMM-DD-YYYY");
            mEndDate = moment.utc(this.state.endDate).tz(moment.tz.guess());
            sEndDate = mEndDate.format("MMM-DD-YYYY");
        }

        let who = "Your";
        if (authService.userType != this.state.cadeModeFor) {
            who = authService.getUserTypeAsString(this.state.cadeModeFor, false);
        }

        let assessmentConcerns = null;
        let assessmentConcernColors = null;
        let lineData = null;
        let barData = null;
        if (this.state.isAvailable) {
            lineData = this.state.progressInfo.map((progInfo) => {
                let mDate = moment.utc(progInfo.date).tz(moment.tz.guess());
                let sDate = mDate.format("MMM-DD-YYYY");
                return {
                    name: sDate,
                    flags: progInfo.numberFlaggedItems
                }
            });

            barData = this.state.progressInfo.map((progInfo) => {
                let mDate = moment.utc(progInfo.date).tz(moment.tz.guess());
                let sDate = mDate.format("MMM-DD-YYYY");
                return {
                    name: sDate,
                    None: progInfo.numberNoConcern,
                    Mild: progInfo.numberMildConcern,
                    Moderate: progInfo.numberModerateConcern,
                    Significant: progInfo.numberSignificantConcern
                }
            });

            assessmentConcernColors = this.state.progressInfo.map((progInfo) => {
                return progInfo.concernLevelColor;
            });

            assessmentConcerns = this.state.progressInfo.map((progInfo) => {
                let mDate = moment.utc(progInfo.date).tz(moment.tz.guess());
                let sDate = mDate.format("MMM-DD-YYYY");
                return { name: sDate, uv: 1 };
            });
        }

        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col sm={4}>
                            <CadeComponentHeader
                                cadeDomain="Assessment"
                                subTitle={subTitle}
                            />
                        </Col>
                        <Col sm={8}>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={4}>
                            <CadeComponentDoodle
                                domainImage={this.state.domainImage}
                                resClickHandler={null}
                                resources={null}
                                resKey={0}
                            />
                        </Col>
                        <Col sm={8}>
                            
                            {this.state.isAvailable &&
                                <Fragment>
                                    <h3>{this.state.progressInfo.length} Assessments</h3>
                                    <h4>{who} Responses</h4>
                                    <h5 className="cadeMonitor_ToFrom"> <Moment format="MMM-DD-YYYY hh:mm A">{mStartDate}</Moment></h5>
                                    <h5 className="cadeMonitor_ToFrom">to</h5>
                                    <h5 className="cadeMonitor_ToFrom"><Moment format="MMM-DD-YYYY hh:mm A">{mEndDate}</Moment></h5>   
                                </Fragment>
                            }
                            {!this.state.isAvailable &&
                                <Fragment>
                                    <h3>Assessment Information Incomplete</h3>
                                    <h4>{who} Responses</h4>
                                    <p>You must have at least 2 completed assessments to monitor progress</p>
                                </Fragment>
                            }
                        </Col>
                    </Row>

                    {this.state.isAvailable &&
                        <Fragment>
                            <Row>
                                <Col sm={12}>
                                    <h4 className="cadeMonitor_ProgressHeading">Overall Concern Level</h4>
                                    <p className="cadeMonitor_ProgressDesc">The overall concern level (no concern = green, mild = yellow, moderate = orange, significant = red) for each time period is shown. Ideally, we want to see the overall concern level moving toward no concern (green) over time. </p>
                                    <ResponsiveContainer height={100}>
                                        <BarChart width={600} height={100} data={assessmentConcerns}
                                            margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                                            <XAxis dataKey="name" />
                                            <YAxis hide tick={false} />
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <Bar dataKey="uv" fill="#8884d8" radius={50} maxBarSize={50} label={false}>
                                                {
                                                    assessmentConcerns.map((entry, index) => (
                                                        <Cell fill={assessmentConcernColors[index % 20]} />
                                                    ))
                                                }
                                            </Bar>
                                        </BarChart>
                                    </ResponsiveContainer>
                                </Col>
                            </Row>

                            <Row>
                                <Col sm={12}>
                                    <h4 className="cadeMonitor_ProgressHeading">Overall Quality of Life</h4>
                                    <p className="cadeMonitor_ProgressDesc">Quality of life measures concerns in areas that affect a person's day-to-day life.  Fewer concerns mean a better chance for a higher quality of life.</p>
                                    <ResponsiveContainer height={300}>
                                        <LineChart width={600} height={300} data={lineData}
                                            margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                                            <XAxis dataKey="name" />
                                            <YAxis type='number' interval="preserveStart" allowDecimals={false} domain={[0, 0]} reversed hide />
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <Tooltip />

                                            <Line type="monotone" dataKey="flags" stroke="#8884d8" strokeWidth={3} activeDot={{ r: 8 }} dot={{ r: 6, strokeWidth: 2 }} />
                                        </LineChart>
                                    </ResponsiveContainer>
                                </Col>
                            </Row>

                            <Row>
                                <Col sm={12}>
                                    <h4 className="cadeMonitor_ProgressHeading">Assessment Item Responses</h4>
                                    <p className="cadeMonitor_ProgressDesc">This graph shows the number of responses in each concern level (no concern, mild, moderate, significant) for each assessment.  Concern levels are indicated by their color: no concern - green, mild - yellow, moderate - orange, significant - red.  The more green and yellow and the less orange and red indicate overall progress.</p>
                                    <ResponsiveContainer height={400}>
                                        <BarChart width={600} height={400} data={barData}
                                            margin={{ top: 10, right: 30, left: 20, bottom: 5 }}>
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <XAxis dataKey="name" />
                                            <YAxis hide />
                                            <Tooltip />
                                            <Legend />
                                            <Bar dataKey="None" stackId="a" fill="#00FF00" />
                                            <Bar dataKey="Mild" stackId="a" fill="yellow" />
                                            <Bar dataKey="Moderate" stackId="a" fill="#F9922C" />
                                            <Bar dataKey="Significant" stackId="a" fill="red" />
                                        </BarChart>
                                    </ResponsiveContainer>
                                </Col>
                            </Row>

                            <Row>
                                <Col sm={12}>
                                    <h4 className="cadeMonitor_ProgressHeading">Domain Progress</h4>
                                    <p className="cadeMonitor_ProgressDesc">Domain progress shows progress made in each domain between the earliest and most recent assessments.  The earliest assessment is shown in the lighter color and the most recent in the darker color.  Progress is indicated if the darker color is "shrinking" towards the center of the graph, ideally moving to the center. </p>
                                    <CadeDomainCompareRadar
                                        t1Label={sStartDate}
                                        t2Label={sEndDate}
                                        progressCompare={this.state.progressCompare}
                                        fullMark={3}
                                        outerRadius={150}
                                    />
                                </Col>
                            </Row>
                        </Fragment>
                    }
                </Container>
            </Fragment>
        )
    }
}

export default CadeMonitorAssessmentComponent;

/*
 * const {LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend} = Recharts;

const lineData = [
            { name: 'Aug 12', flags: 12 },
            { name: 'Sep 8', flags: 11 },
            { name: 'Oct 14', flags: 9 },
            { name: 'Nov 3', flags: 6 },
            { name: 'Dec 20', flags: 3 }
        ];
const SimpleLineChart = React.createClass({
	render () {
  	return (
    	<LineChart width={600} height={300} data={data}
            margin={{top: 5, right: 30, left: 20, bottom: 5}}>
         <XAxis dataKey="name" />
         <YAxis type='number' interval="preserveStart" allowDecimals={false} reversed hide />
         <CartesianGrid strokeDasharray="3 3"/>
         <Tooltip/>

         <Line type="monotone" dataKey="flags" stroke="#8884d8" activeDot={{r: 8}} dot={{ r: 6, strokeWidth: 2 }}/>
      </LineChart>
    );
  }
})

ReactDOM.render(
  <SimpleLineChart />,
  document.getElementById('container')
);



 */


// WEBPACK FOOTER //
// ./src/components/CadeComponent/CadeMonitorAssessmentComponent.js